'use client';
import React, { createContext, useMemo, useState } from 'react';

export const DataRefreshCtx = createContext<{ lastManual: number; mark: () => void }>({
  lastManual: 0,
  mark: () => {},
});

export function DataRefreshProvider({ children }: { children: React.ReactNode }) {
  const [lastManual, setLastManual] = useState(0);
  const value = useMemo(() => ({
    lastManual,
    mark: () => setLastManual(Date.now()),
  }), [lastManual]);
  return <DataRefreshCtx.Provider value={value}>{children}</DataRefreshCtx.Provider>;
}